module.exports = {"350982001":"桐山街道","350982002":"桐城街道","350982003":"山前街道","350982100":"贯岭镇","350982101":"前岐镇","350982102":"沙埕镇","350982103":"店下镇","350982104":"太姥山镇","350982105":"磻溪镇","350982106":"白琳镇","350982107":"点头镇","350982108":"管阳镇","350982109":"嵛山镇","350982200":"硖门畲族乡","350982201":"叠石乡","350982202":"佳阳乡","350982500":"龙安开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350982.json
// module id = 1148
// module chunks = 0